import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'flexibilidadeGd'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/contratos_gd/${id}/flexibilidades_gd`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/flexibilidades_gd/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingFlexibilidadeGdSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingFlexibilidadeGdSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_FLEXIBILIDADE_GD_SUCCESS =
  'LOADING_FLEXIBILIDADE_GD_SUCCESS'
export function loadingFlexibilidadeGdSuccess(flexibilidadeGd) {
  return {
    type: LOADING_FLEXIBILIDADE_GD_SUCCESS,
    flexibilidadeGd,
  }
}

export const DESTROYING_FLEXIBILIDADE_GD_SUCCESS =
  'DESTROYING_FLEXIBILIDADE_GD_SUCCESS'
export function destroyingFlexibilidadeGdSuccess(flexibilidadeGdId) {
  return {
    type: DESTROYING_FLEXIBILIDADE_GD_SUCCESS,
    flexibilidadeGdId,
  }
}

export function fetchMultipleFlexibilidadeGd(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchFlexibilidadeGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createFlexibilidadeGd(parentId, flexibilidadeGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      flexibilidadeGd
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateFlexibilidadeGd(id, flexibilidadeGd) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', flexibilidadeGd).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyFlexibilidadeGd(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const flexibilidadeGd = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_FLEXIBILIDADE_GD_SUCCESS: {
      const { flexibilidadeGd: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_FLEXIBILIDADE_GD_SUCCESS:
      return state.delete(action.flexibilidadeGdId.toString())

    default:
      return state
  }
}

export default flexibilidadeGd